import type { ReactNode } from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { errorClass, hintClass, labelClass } from "@/shared/ui/core/styles";
import { FormFieldContext } from "@/shared/ui/core/formFieldContext";

export function FormField({
  label,
  labelAddon,
  htmlFor,
  required,
  error,
  hint,
  children,
}: {
  label: ReactNode;
  /** Control placed immediately after the label text, such as a help mark. */
  labelAddon?: ReactNode;
  htmlFor?: string;
  /** Shows a required marker (*) next to the label. */
  required?: boolean;
  error?: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <FormFieldContext.Provider value={{ inFormField: true, error, fieldId: htmlFor }}>
      <div className="space-y-1.5">
        <div className="inline-flex items-start gap-1">
          <LabelPrimitive.Root htmlFor={htmlFor} className={labelClass}>
            <span className="inline-block">{label}</span>
            {required ? <VisuallyHidden> (bắt buộc)</VisuallyHidden> : null}
          </LabelPrimitive.Root>
          {labelAddon}
          {required ? (
            <span className="text-danger font-bold text-sm leading-none" aria-hidden="true">
              *
            </span>
          ) : null}
        </div>
        {children}
        {hint && !error ? <p className={hintClass}>{hint}</p> : null}
        {error ? <p className={errorClass}>{error}</p> : null}
      </div>
    </FormFieldContext.Provider>
  );
}

/** Short field-level copy for empty required controls. */
export const REQUIRED_FIELD_MESSAGE = "Bắt buộc";
